import { Integration, LinkedIntegration } from '../models';
import { ModelResource } from './resource';

export interface QuickbooksDesktopAuthUrlResponse {
  auth_url: string;

  end_user_id: string;
}

export interface OAuthAuthorization {
  authorization_code: string;

  redirect_uri: string;

  state?: string | null;

  extra_data?: Record<string, any>;
}

export interface ConnectIntegrationArgs {
  api_subdomain?: string;

  authorization?: OAuthAuthorization;

  credentials?: Record<string, any>;

  settings: Record<string, any>;
}

export class Integrations extends ModelResource<Integration> {
  model = Integration;

  resourcePath = 'v1/integrations';

  async getOAuthUrl(
    integrationName: string,
    data: { redirect_uri: string; settings?: Record<string, any> },
  ): Promise<string> {
    const response = await this.api.post(this.path(integrationName, 'oauth', 'authorization'), {
      data,
    });
    return response.data.url as string;
  }

  async connect(integrationName: string, data: ConnectIntegrationArgs): Promise<LinkedIntegration> {
    const response = await this.api.post(this.path(integrationName, 'connect'), { data });

    return LinkedIntegration.fromJson(response.data);
  }

  async genreateQuickbooksDesktopAuthUrl(
    redirectUrl: string,
  ): Promise<QuickbooksDesktopAuthUrlResponse> {
    const response = await this.api.post(this.path('quickbooks-desktop', 'generate-auth-url'), {
      data: { redirect_url: redirectUrl },
    });
    return response.data as QuickbooksDesktopAuthUrlResponse;
  }
}
